import { api } from "@/lib/api";
import type {
  User,
  LoginDto,
  TrialRequestDto,
  AuthResponse,
  ForgotPasswordDto,
  ResetPasswordDto,
} from "@/types/auth";

export interface UpdateProfileDto {
  name?: string;
  email?: string;
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

class AuthService {
  /**
   * Login with email and password
   * Token is stored in HTTP-only cookie by the backend
   */
  async login(data: LoginDto): Promise<AuthResponse> {
    return api.post<AuthResponse>("/auth/login", data);
  }

  /**
   * Deneme talebi birakir. Public kayit kapali (backend'de
   * PUBLIC_SIGNUP_ENABLED); hesabi talep degerlendirildikten sonra biz aciyoruz.
   */
  async requestTrial(data: TrialRequestDto): Promise<{ message: string }> {
    return api.post<{ message: string }>("/auth/trial-request", data);
  }

  /**
   * Logout the current user
   * Clears the HTTP-only cookie
   */
  async logout(): Promise<void> {
    return api.post("/auth/logout");
  }

  /**
   * Get the current authenticated user
   */
  async getMe(): Promise<User> {
    return api.get<User>("/auth/me");
  }

  /**
   * Refresh the access token using the refresh token cookie
   */
  async refresh(): Promise<{ accessToken?: string }> {
    return api.post<{ accessToken?: string }>("/auth/refresh");
  }

  /**
   * Request password reset email
   */
  async forgotPassword(data: ForgotPasswordDto): Promise<{ message: string }> {
    return api.post<{ message: string }>("/auth/forgot-password", data);
  }

  /**
   * Reset password with token
   */
  async resetPassword(data: ResetPasswordDto): Promise<{ message: string }> {
    return api.post<{ message: string }>("/auth/reset-password", data);
  }

  /**
   * Update user profile
   */
  async updateProfile(data: UpdateProfileDto): Promise<User> {
    return api.patch<User>("/profile", data);
  }

  /**
   * Change password (requires current password verification)
   */
  async changePassword(data: ChangePasswordDto): Promise<{ message: string }> {
    return api.patch<{ message: string }>("/profile", {
      currentPassword: data.currentPassword,
      password: data.newPassword,
    });
  }
}

export const authService = new AuthService();
